import { backgroundDefault } from './helper';
import toolbarItem from './toolbarItem';

export default {
  type: 'outflow',
  name: 'mbst-toolbar',
  aliasName: 'Toolbar',
  properties: {
    backendname: 'toolbar',
    visibility: {
      conditions: [],
      hidden: false
    }
  },
  actions: null,
  css: {
    ios: [
      {
        selector: '.mbst-toolbar',
        rules: [
          { directive: 'width', value: '100%' },
          { directive: 'border-width', value: '0' },
          ...backgroundDefault,
        ]
      }
    ],
    android: [
      {
        selector: '.mbst-toolbar',
        rules: [
          { directive: 'width', value: '100%' },
          { directive: 'border-width', value: '0' },
          ...backgroundDefault,
        ]
      }
    ]
  },
  items: [
    toolbarItem,
    toolbarItem,
  ]
}
